import { Icon } from "@iconify/react";

const Dashnavbar = ({ toggleDrawer, hide }) => {
  return (
    <>
      <div className="dashnavbar-container v-center ">
        <div className={`dashnav-left d-none `}>
          <Icon
            icon="ion:menu"
            width={30}
            height={30}
            onClick={toggleDrawer}
            className={`menu-icon ${hide} `}
          />
        </div>
        <div className="dashnav-right v-center ">
          <h4 className="fw-bold roboto-family">
            AI Powered Document Reduction Tool{" "}
          </h4>
          {/* <label className="elarge text-medium-black fw-medium ">
            Welcome : RTTool Super Admin
          </label> */}
        </div>
        <div></div>
      </div>
    </>
  );
};

export default Dashnavbar;
